/**
 * Unsaved-changes deactivation guard — Story 74.7 (T12, AC12).
 *
 * The repo's FIRST `CanDeactivateFn`. Blocks in-app navigation away from a
 * dirty editor behind a confirm. The companion `beforeunload` handler (tab
 * close / hard reload — outside the router's reach) lives in the editor page
 * component; both are bound by specs.
 *
 * Functional, like the other guards in this directory. Kept generic — any
 * component that exposes `hasUnsavedChanges()` can adopt it.
 */
import { CanDeactivateFn } from '@angular/router';

/** Contract a route component opts into to be protected by this guard. */
export interface UnsavedChangesAware {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (
  component,
) => {
  // No component (route reuse edge) or a clean editor → free to leave.
  if (!component || !component.hasUnsavedChanges()) {
    return true;
  }
  return window.confirm(
    'You have unsaved changes. Leave this issue without saving?',
  );
};
